import { Col, Form } from 'antd'
import React, { FunctionComponent, memo } from 'react'

import { BUYBACK_FIELD as FIELD } from '../../../common/buybackTypes'
import { IncreasingNumber } from '../IncreasingNumber/IncreasingNumber'

export const BuybackFormSummaryFragmentOffer: FunctionComponent = memo(() => {
  const offerPrice = Form.useWatch(FIELD.OfferPrice) ?? 0

  return (
    <Col xs={24} md={12} xl={8} className="text-center">
      <div className="mb-2">Cenová nabídka výkupu nemovitosti</div>
      <IncreasingNumber
        className="text-2xl"
        finalNumber={offerPrice}
        decimal={0}
        suffix=" Kč"
      />
    </Col>
  )
})
